import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TextBoldFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TextBoldFilled({
  title = 'Text bold',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Text bold'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="M17.9 11.5c.7-1 1.1-2.2 1.1-3.5 0-3.3-2.7-6-6-6H5v20h9c3.3 0 6-2.7 6-6 0-1.8-.8-3.4-2.1-4.5ZM9 6h4c1.1 0 2 .9 2 2s-.9 2-2 2H9V6Zm5 12H9v-4h5c1.1 0 2 .9 2 2s-.9 2-2 2Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default TextBoldFilled;